// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"style_chartContainer__f9RXo","totalScore":"style_totalScore__TS_pS"};